(function headerForm($, Drupal) {
  Drupal.behaviors.headerForm = {
    attach(context) {
      // Reference to search.gov form in the header.
      const form = document.getElementById('input-search-form');

      // Adds listener for the 'submit' event.
      form.addEventListener('submit', (e) => {
       // Prevent the browser from submitting the current form.
        e.preventDefault();

       // Keeps track of whether or not the form has been submitted.
       // Prevents the form from being submitted twice in cases where 'hitcallback' fires normally.
        let formSubmitted = false;

        function submitForm() {
          if (!formSubmitted) {
            formSubmitted = true;
            form.submit();
          }
        }

        // Get value from search input.
        const searchText = document.getElementById('header-search').value;

        // Create timeout to call 'submitform' after one second.
        setTimeout(submitForm, 1000);

        // Sends event to google analytics.  Resubmits form once hit is done.
        ga('send', 'event', 'govsearch', 'submit', searchText, { // eslint-disable-line no-undef
          hitcallback: submitForm,
        });
      });
    },
  };
}(jQuery, Drupal));
